import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { api } from "../lib/api";
import { PageBlocks, useDevice } from "../components/builder/BlockRenderer";

export function RenderedPage({ page }) {
  const device = useDevice();
  useEffect(() => { if (page) document.title = page.seo_title || page.title || document.title; }, [page]);
  return <div data-testid="public-page" className="min-h-[60vh]"><PageBlocks blocks={page.blocks} device={device} /></div>;
}

export default function PageView() {
  const { slug } = useParams();
  const [page, setPage] = useState(undefined);
  useEffect(() => {
    setPage(undefined);
    api.get(`/pages/${slug}`).then((r) => setPage(r.data)).catch(() => setPage(null));
  }, [slug]);
  if (page === undefined) return <div className="py-40 flex justify-center text-zinc-500"><Loader2 className="animate-spin" /></div>;
  if (!page) return <div className="py-40 text-center text-zinc-400" data-testid="page-not-found"><p className="font-display text-3xl">Page not found</p><p className="text-sm text-zinc-500 mt-2">This page may be unpublished or moved.</p></div>;
  return <RenderedPage page={page} />;
}
